import { render, staticRenderFns } from "./VvSplashButton.vue?vue&type=template&id=7202428a&scoped=true&"
import script from "./VvSplashButton.vue?vue&type=script&lang=js&"
export * from "./VvSplashButton.vue?vue&type=script&lang=js&"
import style0 from "./VvSplashButton.vue?vue&type=style&index=0&id=7202428a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7202428a",
  null
  
)

export default component.exports